
import { SearchTextMatchMethod } from "./SearchTextMatchMethod"
import { CardGroupBy, CardSortBy } from "./Card"
import { DeckCardsViewType } from "./Deck"

export type UserSettings = {
    id: string,
    displayName: string,
    isDarkMode: boolean,
    deckCollectionIntegration: boolean,
    deckFullScreenCardSearch: boolean,
    defaultDeckView: DeckCardsViewType,
    foilIndicator: boolean,
    hideCardPrice: boolean,

    printableDeckListGroupBy: CardGroupBy,
    printableDeckListSortBy: CardSortBy,
    deckBuilderAllVariants: boolean,
    primarySerialOnly: boolean,
    openDecksInNewTab: boolean,
    deckFolders: string[],
    defaultSearchTextMatchMethod: SearchTextMatchMethod
}

export type SaveDisplayNameRequestBody = {
    displayName: string
}

export function getDefaultUserSettings(): UserSettings {
    return {
        id: "",
        displayName: "",
        isDarkMode: false,
        deckCollectionIntegration: false,
        deckFullScreenCardSearch: false,
        defaultDeckView: "List",
        foilIndicator: true,
        printableDeckListGroupBy: "Type",
        printableDeckListSortBy: "Serial (Desc)",
        deckBuilderAllVariants: false,
        primarySerialOnly: false,
        openDecksInNewTab: false,
        hideCardPrice: false,
        deckFolders: [],
        defaultSearchTextMatchMethod: "all"
    };
}

export function getUserSettingsOrDefault(userSettings: UserSettings): UserSettings {
    const defaultSettings = getDefaultUserSettings();

    if (!userSettings) {
        return defaultSettings;
    }

    return {
        id: userSettings.id ? userSettings.id : defaultSettings.id,
        displayName: userSettings.displayName ? userSettings.displayName : defaultSettings.displayName,
        isDarkMode: userSettings.isDarkMode ? userSettings.isDarkMode : defaultSettings.isDarkMode,
        deckCollectionIntegration: userSettings.deckCollectionIntegration ? userSettings.deckCollectionIntegration : defaultSettings.deckCollectionIntegration,
        deckFullScreenCardSearch: userSettings.deckFullScreenCardSearch ? userSettings.deckFullScreenCardSearch : defaultSettings.deckFullScreenCardSearch,
        defaultDeckView: userSettings.defaultDeckView ? userSettings.defaultDeckView : defaultSettings.defaultDeckView,
        foilIndicator: userSettings.foilIndicator !== undefined ? userSettings.foilIndicator : defaultSettings.foilIndicator,
        printableDeckListGroupBy: userSettings.printableDeckListGroupBy ? userSettings.printableDeckListGroupBy : defaultSettings.printableDeckListGroupBy,
        printableDeckListSortBy: userSettings.printableDeckListSortBy ? userSettings.printableDeckListSortBy : defaultSettings.printableDeckListSortBy,
        deckBuilderAllVariants: userSettings.deckBuilderAllVariants ? userSettings.deckBuilderAllVariants : defaultSettings.deckBuilderAllVariants,
        primarySerialOnly: userSettings.primarySerialOnly ? userSettings.primarySerialOnly : defaultSettings.primarySerialOnly,
        openDecksInNewTab: userSettings.openDecksInNewTab ? userSettings.openDecksInNewTab : defaultSettings.openDecksInNewTab,
        hideCardPrice: userSettings.hideCardPrice !== undefined ? userSettings.hideCardPrice : defaultSettings.hideCardPrice,
        deckFolders: userSettings.deckFolders ? userSettings.deckFolders : defaultSettings.deckFolders,
        defaultSearchTextMatchMethod: userSettings.defaultSearchTextMatchMethod ? userSettings.defaultSearchTextMatchMethod : defaultSettings.defaultSearchTextMatchMethod
    };
}